<div class="unauthorized-container">
  <h2>Accesso Negato</h2>
  <p>Il tuo profilo non ti permette di accedere a questa sezione dell'applicativo, contatta xyz@mail.com per farti abilitare</p>
</div>
